import AgendaViewBase from '../AgendaViewBase/AgendaViewBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AttendanceList.html?raw';
import "../AttendanceList/AttendanceListTypes";
import AttendanceListEditor from './AttendanceListEditor/AttendanceListEditor';
import "./AttendanceListEditor/AttendanceListEditor";
import FullscreenDialog from '../../moreCore/UI/FullscreenDialog/FullscreenDialog';
import "../../moreCore/UI/FullscreenDialog/FullscreenDialog";
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import "../../moreCore/UI/GenericDialog/GenericDialog";

class AttendanceList extends compose(AgendaViewBase<any>) {
	templateString: any = template;


    fullScreenDlg: MdsLax<InstanceType<typeof FullscreenDialog>>;
    genericDialog: MdsLax<InstanceType<typeof GenericDialog>>;


    defaultLayouts: Array<StaticTable.Layout> = [{
        name: "default",
        label : "",
        rows: [{
            attributes: [
                "",
                "ref_ev_project.$Displayname",
                "ref_ev_activity_status.description",
                "ev_booking_name",
            ],
            colspans: [
                1,
                1,
                1,
                1,
            ],
            widths: ["15%", "45%", "20%", "20%"],
            colorationStyle: "bottom-left",
            mainColorationValue: "ref_ev_activity_status.coloration",
            headings: [
                (this as any).translations["WebCalendar_SidebarLabel_Date"],
                (this as any).translations["AttendanceList__LayoutHeader_project"],
                (this as any).translations["AttendanceList__LayoutHeader_activityStatus"],
                (this as any).translations["AttendanceList__LayoutHeader_Booking"],
            ],
            colNamesInternal: [
                (this as any).translations["WebCalendar_SidebarLabel_Date"],
                (this as any).translations["AttendanceList__LayoutHeader_project"],
                (this as any).translations["AttendanceList__LayoutHeader_activityStatus"],
                (this as any).translations["AttendanceList__LayoutHeader_Booking"],
            ]
        }]
    }];

    bookingTable_formatterFunction: Function = lang.hitch(this,
        function (cell: StaticTable.StaticTableCell<FileFinder.FileDescriptor>) {
            let node = cell.contentnode;
            let entity = cell.entity;
            let colName = cell.name;
            let value = cell.value;
            switch (colName) {
                case (this as any).translations["WebCalendar_SidebarLabel_Date"]:
                    let dateFrom = entity["date_start"];
                    let dateTo = entity["date_end"];

                    if (dateFrom.slice(5, 7) == dateTo.slice(5, 7) && dateFrom.slice(8, 10) == dateTo.slice(8, 10)) {
                        var sYear: string = dateFrom.slice(0, 4);
                        var sMonth: string = dateFrom.slice(5, 7);
                        var sDay: string = dateFrom.slice(8, 10);
                        var sHourFrom: string = dateFrom.slice(11, 13);
                        var sHourTo: string = dateTo.slice(11, 13);
                        var sMinuteFrom: string = dateFrom.slice(14, 16);
                        var sMinuteTo: string = dateTo.slice(14, 16);
                        node.innerHTML = `${sDay}.${sMonth}.${sYear}, ${sHourFrom}:${sMinuteFrom} - ${sHourTo}:${sMinuteTo}`
                    } else {
                        node.innerHTML = (this as any).convertISOStringDateToLocalString(dateFrom) + " - " + (this as any).convertISOStringDateToLocalString(dateTo)
                    }
                    return true;    
                break;

                default:
                    return false;
            }
    });


    // je nach dem ob sich die Widgets ersetzen sollen oder synchronisieren usw.
    
    tableRowButton_click_edit(rowData): void {
        
        //this.createAttendanceListEditor(rowData.rowGroup);
    }

    createAttendanceListEditor = function (cellData): void {
        let rowData = cellData.rowGroup
        if ((this as any).genericDialog != null) {
            (this as any).genericDialog.destroy();
            (this as any).genericDialog = null;
        }

        let dialogHeader = rowData.entity["ev_booking_name"] + "<br>" + (this as any).convertISOStringDateToLocalString(rowData.entity["date_start"]) + " - " +
            (this as any).convertISOStringDateToLocalString(rowData.entity["date_end"]) + "<br>" + (this as any).translations["AttendanceList_tableHeader__dirigent"] + ": " + rowData.entity["conductor_webplan"];

        (this as any).genericDialog = new GenericDialog();
        (this as any).genericDialog.set("header", dialogHeader);

        let attendanceListEditor = new AttendanceListEditor();
        (this as any).genericDialog["attendanceListEditor"] = attendanceListEditor;
        attendanceListEditor.placeAt((this as any).genericDialog.textNode);

        attendanceListEditor.loadData(rowData.entity["ID"]);
        let genericDialog: MdsLax<InstanceType<typeof GenericDialog>> = (this as any).genericDialog;
        genericDialog.set("closeBtn", true);
        genericDialog.set("topCloseBtn", true);
        genericDialog.addButton(
            "showAll",
            (this as any).translations["AttendanceListEditor__showAllEmployments"],
            lang.hitch(this, "_onShowAllEmploymentsClick"),
            null,
            "accentBG", null,
            false);
        //this.genericDialog.setUserdefinedButton();

        attendanceListEditor.batchEditButton = (this as any).UiModder.domConstruct.create("div", {
            className: "mds-button-base w3-padding w3-round accentBG mds-hover-bright",
            innerHTML: (this as any).translations["AttendanceList__batchEditButtonLabel_single"],
            style: {
                minWidth: "120px",
                marginLeft: "10px"
            },
            onclick: lang.hitch(attendanceListEditor, "_onclickBatchEditButton")
        }, (this as any).genericDialog.actionContainerNode, "first")

        (this as any).genericDialog.close = (this as any).genericDialog_closeFunction;
        (this as any).genericDialog.on("closed", lang.hitch(this, "_onAttendanceListEditorClose"));
        (this as any).genericDialog.open();
    }
    _onShowAllEmploymentsClick(): void {
        let showOpenOnly: boolean = this.genericDialog["attendanceListEditor"].notInspectedOnly;
        this.genericDialog["attendanceListEditor"].notInspectedOnly = !showOpenOnly;
        let button = this.genericDialog.getButtonByName("showAll");

        if (showOpenOnly == true) {
            if (button) {
                this.UiModder.domAttr.set(button.node, "innerHTML", this.translations["AttendanceListEditor__showOnlyNotInspected"]);
            }
        } else {
            if (button) {
                this.UiModder.domAttr.set(button.node, "innerHTML", this.translations["AttendanceListEditor__showAllEmployments"]);
            }
        }

        this.genericDialog["attendanceListEditor"].createTable();

        this.genericDialog["attendanceListEditor"].setMarkedRowsStyle(true);
    }

    _onAttendanceListEditorClose(): void {
        //this.setPage(this._currentPage, true);
    }

    // generic Dialog scope
    genericDialog_closeFunction = function (result?: any): void {
        if ((this as any)._is_dlg_active && (this as any).modalDlgNode) {
            let close_unsaved: boolean = true;

            if ((this as any).attendanceListEditor.isBatchEditingActive == false && (this as any).attendanceListEditor.unsavedRowIndexes.length > 0) {
                close_unsaved = confirm((this as any).translations["AppointmentToDoListEditor_unsavedChanges"]);
            } else if ((this as any).attendanceListEditor.isBatchEditingActive == true && (this as any).attendanceListEditor._isBEValuelDirty() == true) {
                close_unsaved = confirm((this as any).translations["AppointmentToDoListEditor_unsavedChanges"]);
            }

            if (close_unsaved == true) {
                (this as any).UiModder.domStyle.set((this as any).modalDlgNode, "display", "none");

                if (typeof (result) == "undefined") {
                    result = 0;
                } else if (typeof (result) == "function") {
                    result();
                }

                setTimeout(lang.partial((this as any).callback, result), 1);

                if ((this as any).destroyOnClose === true) {
                    setTimeout(lang.hitch(this, "destroy"), 1000);
                }

                (this as any).emit("closed", { result: result });
            }
        }
    }

    initAgendaView() {
        this.setupAgendaView(
            "AttendanceList/GetFilterpanelOptions",
            "AttendanceList/GetEventList",
            lang.hitch(this, this.createAttendanceListEditor),
            lang.hitch(this, this.bookingTable_formatterFunction)
        );
    }

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.initAgendaView();
        this.setTitles(this.translations["NavigationTile__AttendanceList"], this.translations["NavigationTile__AttendanceList"]);
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AttendanceList);